import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const getDailyAISummary = async (organisationId) => {
  const response = await axiosInstance.get(
    `${API_URL}/ai-summary/daily-summary`);
  return response.data;
};
